<div class="ya-typography" [ngClass]="isEMenu? 'emenu':''">
  <mat-sidenav-container #sidenavcontainer autosize id="matDrawerContainer">

    <mat-sidenav *ngIf="!isSmallView; sideNavTemplate" class="sidenav" [style.] role="heading" aria-level="1"
      id="mainNav">
      <header class="header">
        <div class="container">
          <nav class="nav" role="navigation">
            <ng-container *ngIf="useNavigation">
              <div class="main-nav">
                <mat-nav-list class="ya-scrollbar-y">
                  <ng-container *ngFor="let sideMenu of subMenu; let isLast = last">
                    <ng-container *ngIf="isLast; then impressumTemplate else sideNavTemplate"></ng-container>
                    <ng-template #sideNavTemplate>
                      <a a11y_Button [attr.id]="'navigation'+sideMenu.contentType" class="side-navigation-class"
                        mat-list-item (click)="navigateToModule($event,sideMenu)">
                        {{sideMenu.label}}
                      </a>
                    </ng-template>
                    <ng-template #impressumTemplate>
                      <!-- <a [attr.id]="'navigation'+sideMenu.contentType" class="navigation-class" mat-list-item
                      (click)="navigateToModule($event,sideMenu)">
                     
                      {{sideMenu.label}}
                    </a> -->
                    </ng-template>
                  </ng-container>
                </mat-nav-list>
              </div>
            </ng-container>
          </nav>
          <div class="logo">
            <img rel="preload" alt="Logo" src="assets/custom/image/AppLogo.png" />
          </div>
          <nav class="nav" role="navigation">
            <div class="user">
              <ng-container *ngIf="!inHouseIsGroup && inHouseHasTableSeat">
                <a a11y_Button @plopInOut ngClass="item-basket-count" routerLink="/inHauseServiceSelector"
                  [matBadgeHidden]="mandatoryPayment" [matBadge]="inHouseTableOpenItems" matBadgeSize="small"
                  matBadgePosition="below before">
                  <div class="inline-icon main-header-icon" inlineSVG="shop-icons.svg#ya-hypersoft-tisch-voll"></div>
                </a>
              </ng-container>
              <ng-container *ngIf="inHouseIsGroup && inHouseHasTableSeat">
                <a a11y_Button @plopInOut ngClass="item-basket-count" routerLink="/groupOrderServiceSelector"
                  [matBadge]="showInhouseGroupMemberCount" matBadgeSize="small" matBadgePosition="below before">
                  <div class="inline-icon main-header-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-multi">
                  </div>
                </a>
              </ng-container>
              <!-- Remote group order-->
              <ng-container *ngIf="!(groupStatusFinished$|async)">
                <ng-container *ngIf="displayRemoteOrderGroupIcon$|async">
                  <a @plopInOut ngClass="remote-group" routerLink="/remoteOrderGroupServiceSelector"
                    [matBadge]="showRemoteGroupMemberCount(remoteGroupMemberCount$|async)" matBadgeSize="small"
                    matBadgePosition="below before">
                    <div class="inline-icon main-header-icon" inlineSVG="hypersoft-user-multi.svg">
                    </div>
                  </a>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!isRemoteOrderGroup && itemsInBasket > 0">
                <a a11y_Button @plopInOut ngClass="item-basket-count" routerLink="/webshop" [matBadge]="itemsInBasket"
                  matBadgeSize="small" matBadgePosition="below before" data-testid="cart-badge-count">
                  <div id="header-icon-basket" class="inline-icon main-header-icon"
                    inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp">
                  </div>
                </a>
              </ng-container>
              <ng-container
                *ngIf="!inHouseHasTableSeat && !inHouseIsGroup;then  LocationCheckTemplate else NoLocationCheckTemplate"></ng-container>
              <ng-template #LocationCheckTemplate>
                <ng-container *ngIf="(isLocationCheckedIn && useNavigation)">
                  <a a11y_Button @plopInOut (click)="openChangeLocationDialog()"
                    class="header-tools-wrapper main-header-account">
                    <div id="header-icon-location" class="inline-icon main-header-icon"
                      inlineSVG="shop-icons.svg#ya-hypersoft-standort">
                    </div>
                    <div class="checkmark-container">
                      <div class="inline-icon onlile-account-checkmark"
                        inlineSVG="shop-icons.svg#ya-hypersoft-check-voll">
                      </div>
                    </div>
                  </a>
                </ng-container>
              </ng-template>
              <ng-template #NoLocationCheckTemplate>
              </ng-template>
              <ng-container *ngIf="isRegistered; then registeredUser else offlineUser"></ng-container>
              <ng-template #offlineUser>
                <a a11y_Button @plopInOut (click)="openLoginDialog()" class="header-tools-wrapper main-header-account">
                  <div id="header-icon-user" class="inline-icon main-header-icon"
                    inlineSVG="shop-icons.svg#ya-hypersoft-user-single">
                  </div>
                </a>
              </ng-template>
              <ng-template #registeredUser>
                <a a11y_Button @plopInOut routerLink="/userprofile" class="header-tools-wrapper main-header-account">
                  <div id="header-icon-user" class="inline-icon main-header-icon"
                    inlineSVG="shop-icons.svg#ya-hypersoft-user-single">
                  </div>
                  <div class="checkmark-container">
                    <div class="inline-icon onlile-account-checkmark"
                      inlineSVG="shop-icons.svg#ya-hypersoft-check-voll">
                    </div>
                  </div>
                </a>
              </ng-template>
            </div>
          </nav>
        </div>
      </header>
    </mat-sidenav>

    <mat-sidenav *ngIf="isSmallView; sideNavTemplate" #drawer (swiperight)="drawer.close()"
      [position]="isSmallView? 'end' : 'start'" class="sidenav" [style.] fixedInViewport="true"
      [mode]="isSmallView ? 'over' : 'side'" role="navigation" [autoFocus]="false" [@.disabled]="true"
      [ngClass]="isEMenu?'hidden':''">
      <span class="sidenav-appName-container">
        <img rel="preload" alt="Logo" src="assets/custom/image/AppLogo.png" />
      </span>
      <mat-nav-list class="ya-scrollbar-y">
        <ng-container *ngFor="let sideMenu of subMenu; let isLast = last">
          <ng-container *ngIf="isLast; then impressumTemplate else sideNavTemplate"></ng-container>
          <ng-template #sideNavTemplate>
            <a a11y_Button [attr.id]="'navigation'+sideMenu.contentType" class="side-navigation-class" mat-list-item
              (click)="navigateToModule($event,sideMenu)">
              <div class="inline-icon hypersoft-icon mainnav-submenu" [inlineSVG]="sideMenu.svgName+'.svg'"></div>
              {{sideMenu.label}}
            </a>
          </ng-template>
          <ng-template #impressumTemplate>
            <mat-divider></mat-divider>
            <ng-container *ngIf="isRevokeEnabled">
              <a a11y_Button mat-list-item class="navigation-class" (click)="navigateToRevokeOrder()">
                <div class="inline-icon hypersoft-icon mainnav-submenu" inlineSVG="shop-icons.svg#ya-undo"></div>
                <span class="revoke-order-link-text" langkey="phRevokeOrder_FooterLink"></span>
              </a>
            </ng-container>
            <a a11y_Button [attr.id]="'navigation'+sideMenu.contentType" class="navigation-class" mat-list-item
              (click)="navigateToModule($event,sideMenu)">
              <div class="inline-icon hypersoft-icon mainnav-submenu" [inlineSVG]="sideMenu.svgName+'.svg'"></div>
              {{sideMenu.label}}
            </a>
          </ng-template>
        </ng-container>
        <ng-container *ngIf="!isMobile">
          <a a11y_Button mat-list-item class="navigation-class" (click)="openCookieDialog()">
            <div class="inline-icon hypersoft-icon mainnav-submenu" inlineSVG="shop-icons.svg#ya-hypersoft-cookie">
            </div>
            <span langkey="phCookie_Cookie"></span>
          </a>
        </ng-container>
        <ng-container>
          <a a11y_Button mat-list-item class="navigation-class" (click)="openLicenseDialog()">
            <div class="inline-icon hypersoft-icon mainnav-submenu" inlineSVG="shop-icons.svg#ya-hypersoft-news">
            </div>
            <span langkey="phLicense_Licenses"></span>
          </a>
        </ng-container>
        <ng-container>
          <a a11y_Button mat-list-item class="side-navigation-class" (click)="openAccessibiltyDialog()">
            <div class="inline-icon hypersoft-icon mainnav-submenu" inlineSVG="hypersoft-accessibilty.svg"></div>
            <span langkey="phA11YDialog_Headline"></span>
            <div *ngIf="isAccessibilityModeActive" class="a11y-check-small">
              <div class="inline-icon a11y-check-svg" inlineSVG="done.svg">
              </div>
            </div>
          </a>
        </ng-container>
        <ng-container *ngIf="!isProductionMode">
          <a a11y_Button mat-list-item routerLink="/debugview">Debug View</a>
          <a a11y_Button mat-list-item routerLink="/registrationdata">registrationdata</a>
          <a a11y_Button mat-list-item routerLink="/qrcodescanner">qrcodescanner</a>
          <a a11y_Button mat-list-item routerLink="/checkout">Checkout</a>
          <a a11y_Button mat-list-item routerLink="/menuserviceselection">menuserviceselection</a>
          <a a11y_Button mat-list-item routerLink="/menulocation">menulocation</a>
          <a a11y_Button mat-list-item routerLink="/webshop">webshop</a>
          <a a11y_Button mat-list-item (click)="registerPushNotification()">RegisterPushMsg</a>
          <a a11y_Button mat-list-item (click)="unregisterPushNotification()">UnregisterPushMsg</a>
          <a a11y_Button mat-list-item (click)="sendPushNotification()">SendPushMsg</a>
          <a a11y_Button mat-list-item (click)="resetFCM()">ResetFCM</a>
          <a a11y_Button mat-list-item (click)="openSnackBar()">Snackbar</a>
          <input a11y_Input mat-list-item id="smsnumber" placeholder="SMS Number" />
          <a a11y_Button mat-list-item (click)="registerSMSNotification()">RegisterSMSMsg</a>
          <a a11y_Button mat-list-item (click)="unregisterSMSNotification()">UnregisterSMSMsg</a>
          <a a11y_Button mat-list-item (click)="sendSMSNotification()">SendSMSMsg</a>
        </ng-container>
      </mat-nav-list>

      <ng-container *ngIf="communities.length > 0">
        <div class="sidenav-footerbar-communities">
          <div class="sidenav-footerbar-communities-title" langkey="phMainNav_Community"></div>
          <div class="communities-container">
            <ng-container *ngFor="let community of communities">
              <a class="sidenav-footerbar-communities-svg" [inlineSVG]="community.image"
                (click)="openExternalUrl(community.url)"></a>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <mat-divider></mat-divider>
      <div class="sidenav-footerbar">
        <div *ngIf="canSelectLanguage" class="sidenav-language-container">
          <a a11y_Button mat-icon-button [ngClass]="['mat-icon-button', 'mainFooter-nav', 'ya-body-1']"
            (click)="openLanguageDialog()">
            <div class="inline-icon ya-language-icon" [inlineSVG]="'shop-icons.svg#ya-flag-' + (currentLocale || 'de')">
            </div>
          </a>
        </div>
        <div class="version-info">{{version}}</div>
      </div>
    </mat-sidenav>
    <mat-sidenav-content id="sideNavContent" role="main"
      [ngClass]="isIOS? 'mat-nav-content-mobile':'mat-nav-content-browser'">
      <div *ngIf="isSmallView" class="main-header" [ngClass]="isIOS?'main-header-IOS':'main-header-Android'">
        <ng-container *ngIf="!isEMenu">
          <div class="main-header-center">
            <ng-container *ngIf="isSmallView">
              <span class="appName">
                <img rel="preload" alt="Logo" src="assets/custom/image/AppLogo.png" />
              </span>
            </ng-container>
          </div>

          <ng-container *ngIf="isSmallView">
            <div class="main-header-tools">
              <!-- Linke Gruppe: Service-Icons (Tisch, InHouse Gruppe, Remote Gruppe) -->
              <div class="main-header-tools-left">
                <ng-container *ngIf="!inHouseIsGroup && inHouseHasTableSeat">
                  <a a11y_Button @plopInOut ngClass="item-basket-count" routerLink="/inHauseServiceSelector"
                    [matBadge]="inHouseTableOpenItems" matBadgeSize="small" matBadgePosition="below before"
                    [matBadgeHidden]="mandatoryPayment">
                    <div class="inline-icon main-header-icon" inlineSVG="shop-icons.svg#ya-hypersoft-tisch-voll"></div>
                  </a>
                </ng-container>
                <ng-container *ngIf="inHouseIsGroup && inHouseHasTableSeat">
                  <a a11y_Button @plopInOut ngClass="item-basket-count" routerLink="/groupOrderServiceSelector"
                    [matBadge]="showInhouseGroupMemberCount" matBadgeSize="small" matBadgePosition="below before">
                    <div class="inline-icon main-header-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-multi">
                    </div>
                  </a>
                </ng-container>
                <!-- Remote group order-->
                <ng-container *ngIf="!(groupStatusFinished$|async)">
                  <ng-container *ngIf="displayRemoteOrderGroupIcon$|async">
                    <a @plopInOut ngClass=" remote-group" routerLink="/remoteOrderGroupServiceSelector"
                      [matBadge]="showRemoteGroupMemberCount(remoteGroupMemberCount$|async)" matBadgeSize="small"
                      matBadgePosition="below before">
                      <div class="inline-icon main-header-icon" inlineSVG="hypersoft-user-multi.svg">
                      </div>
                    </a>
                  </ng-container>
                </ng-container>
              </div>

              <!-- Rechte Gruppe: Standort, User, Warenkorb -->
              <div class="main-header-tools-right">
                <ng-container
                  *ngIf="!inHouseHasTableSeat && !inHouseIsGroup;then  LocationCheckTemplate else NoLocationCheckTemplate"></ng-container>
                <ng-template #LocationCheckTemplate>
                  <ng-container *ngIf="(isLocationCheckedIn && useNavigation)">
                    <a a11y_Button @plopInOut (click)="openChangeLocationDialog()"
                      class="header-tools-wrapper main-header-account">
                      <div id="header-icon-location" class="inline-icon main-header-icon"
                        inlineSVG="shop-icons.svg#ya-hypersoft-standort">
                      </div>
                      <div class="checkmark-container">
                        <div class="inline-icon onlile-account-checkmark"
                          inlineSVG="shop-icons.svg#ya-hypersoft-check-voll">
                        </div>
                      </div>
                    </a>
                  </ng-container>
                </ng-template>
                <ng-template #NoLocationCheckTemplate>
                </ng-template>

                <ng-container *ngIf="isRegistered; then registeredUser else offlineUser"></ng-container>
                <ng-template #offlineUser>
                  <a a11y_Button @plopInOut (click)="openLoginDialog()"
                    class="header-tools-wrapper main-header-account">
                    <div id="header-icon-user" class="inline-icon main-header-icon"
                      inlineSVG="shop-icons.svg#ya-hypersoft-user-single">
                    </div>
                  </a>
                </ng-template>
                <ng-template #registeredUser>
                  <a a11y_Button @plopInOut routerLink="/userprofile" class="header-tools-wrapper main-header-account">
                    <div id="header-icon-user" class="inline-icon main-header-icon"
                      inlineSVG="shop-icons.svg#ya-hypersoft-user-single">
                    </div>
                    <div class="checkmark-container">
                      <div class="inline-icon onlile-account-checkmark"
                        inlineSVG="shop-icons.svg#ya-hypersoft-check-voll">
                      </div>
                    </div>
                  </a>
                </ng-template>

                <ng-container *ngIf="!isRemoteOrderGroup && itemsInBasket > 0">
                  <a a11y_Button @plopInOut ngClass="item-basket-count" routerLink="/webshop" [matBadge]="itemsInBasket"
                    matBadgeSize="small" matBadgePosition="below before" data-testid="cart-badge-count">
                    <div id="header-icon-basket" class="inline-icon main-header-icon"
                      inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp">
                    </div>
                  </a>
                </ng-container>
              </div>
            </div>
          </ng-container>

        </ng-container>
        <ng-container *ngIf="isEMenu">
          <div @plopInOut *ngIf="canSelectLanguage" class="sidenav-language-container emenu">
            <a a11y_Button mat-icon-button [ngClass]="['mat-icon-button', 'mainFooter-nav', 'ya-body-1']"
              (click)="drawer.close();openLanguageDialog()">
              <div class="inline-icon ya-language-icon"
                [inlineSVG]="'shop-icons.svg#ya-flag-' + (currentLocale || 'de')"></div>
            </a>
          </div>
        </ng-container>
      </div>
      <ng-content></ng-content>

      <ng-container *ngIf="useNavigation">
        <div class="footer-anchor">
          <ng-container *ngIf="isSmallView">
            <div #mainFooter class="ya-typography main-footer-toolbar"
              [ngClass]="[(!isSmallView || isEMenu)? 'hidden':'']" [@toggleBottomNav]="isVisible">
              <div #navBottomToolbar class="footer-navigation"
                [ngClass]="[(fullFooterMenu) ? 'footer-navigation-full' : 'footer-navigation-space-around']">
                <ng-container
                  *ngFor="let customerFooterMenu of mainMenu; let isHomeMenu = first; let menuLength = count">
                  <a a11y_Button [buttonCount]="menuLength" footerLabelWidth
                    [attr.id]="'navigation'+customerFooterMenu.contentType" class="navigation-class"
                    (click)="navigateToModule($event,customerFooterMenu)"
                    [ngClass]="isHomeMenu?['mat-icon-button', 'mainFooter-nav', 'highlight-icon']:['mat-icon-button', 'mainFooter-nav']"
                    mat-icon-button disableRipple>
                    <div class="inline-icon hypersoft-icon" [inlineSVG]="customerFooterMenu.svgName+'.svg'"></div>
                    <span>{{customerFooterMenu.label}}</span>
                  </a>
                </ng-container>
                <a a11y_Button mat-icon-button id="moreMenu" footerLabelWidth class="navigation-class"
                  [ngClass]="['mat-icon-button', 'mainFooter-nav']" (click)="drawer.open()" disableRipple>
                  <div class="inline-icon hypersoft-icon" inlineSVG="shop-icons.svg#ya-more_horiz"></div>
                  <span langkey="phMainNav_More"></span>
                </a>
              </div>
            </div>
          </ng-container>

        </div>
      </ng-container>
      <div id="offlineindicator" class="offlineindicator"
        [@toggleOfflineIndicator]="{value: isOffline, params: {activeColor: offlineIndicatorActiveColor}}">
        <div *ngIf="isOffline; then thenNoConnection else elseBackOnline"></div>
        <ng-template #thenNoConnection><span langkey="phOfflineIndicator_NoConnection"></span></ng-template>
        <ng-template #elseBackOnline><span langkey="phOfflineIndicator_BackOnline"></span></ng-template>
      </div>
      <!-- Add Content Here -->
    </mat-sidenav-content>

  </mat-sidenav-container>

  <!--Cookie Banner only in Browser-->
  <ng-container *ngIf="!isMobile">
    <ng-container *ngIf="showCookiebanner">
      <cookiebanner></cookiebanner>
    </ng-container>
  </ng-container>
  <!--IOS : redirect to app-->
  <banner></banner>
</div>